// https://noom.github.io/growth/#colors
export const ASSET_URL = "https://fe-web-assets.noom.com/";
export const Color = {
    gray: {
        dark: "#4D4D4D",
        main: "#969696",
        light: "#CACACA",
        lightest: "#F2F2F2",
    },
    sun: {
        dark: "#C28800",
        main: "#FFCF04",
        light: "#FFE782",
        lightest: "#FFF5CD",
    },
    orange: {
        dark: "#C36000",
        main: "#FF8A1A",
        light: "#F8BD85",
        lightest: "#FFE7CF",
    },
    cherry: {
        dark: "#9C0300",
        main: "#E73B37",
        light: "#EC9694",
        lightest: "#FFDAD9",
    },
    watermelon: {
        dark: "#B12C37",
        main: "#F75462",
        light: "#FBA9B0",
        lightest: "#FFDEE1",
    },
    eggplant: {
        dark: "#6F1056",
        main: "#BB4F9F",
        light: "#D6A0C8",
        lightest: "#FDDDF5",
    },
    violet: {
        dark: "#2F0062",
        main: "#7A00FD",
        light: "#B578F7",
        lightest: "#F1E4FF",
    },
    pbr: {
        dark: "#183C78",
        main: "#447AD4",
        light: "#A1BCE9",
        lightest: "#ECF2FB",
    },
    sea: {
        dark: "#005254",
        main: "#30C1C5",
        light: "#90D9DB",
        lightest: "#E4FEFF",
    },
    apple: {
        dark: "#123806",
        main: "#16AA00",
        light: "#83CD78",
        lightest: "#E9FFE3",
    },
};
export const CompassColor = {
    // Reds/Oranges
    cherry: "#5F110E",
    cinnamon: "#AA3521",
    tarocco: "#FB513B",
    salmon: "#F4BEAE",
    // Purples/Pinks
    plum: "#671D48",
    berry: "#A82F67",
    blossom: "#F2AACD",
    conch: "#EBCCD9",
    // Greens
    pine: "#2B4010",
    kale: "#316700",
    avocado: "#799F2D",
    sprout: "#A9D15A",
    mint: "#C8E3B1",
    mintLight: "#E3F1D8",
    // Blues
    blueberry: "#1D3A44",
    lagoon: "#05727A",
    lagoonTint: "#378e95",
    lagoonShade: "#045B62",
    stream: "#6CC1B6",
    sky: "#B4E0D8",
    // Yellows
    yolk: "#EAAF00",
    // Tans
    gold: "#AD925E",
    sand01: "#E4DECE",
    sand02: "#D3C9B4",
    offWhite: "#F6F4EE",
    // Whites/Greys/Blacks
    white: "#FFFFFF",
    grey1: "#DEDEDE",
    grey2: "#AAAAAA",
    grey3: "#666666",
    // duplicated for backwards compatibility
    stone: "#666666",
    grey4: "#444444",
    black: "#191717",
};
export const Size = {
    full: "full",
    xxxl: "3xl",
    xxl: "2xl",
    xl: "xl",
    lg: "lg",
    md: "md",
    sm: "sm",
    xs: "xs",
};
export const Variant = {
    outline: "outline",
    filled: "filled",
    flushed: "flushed",
    unstyled: "unstyled",
    ghost: "ghost",
    link: "link",
    solid: "solid",
};
export const Status = {
    info: "info",
    success: "success",
    warning: "warning",
    error: "error",
};
export const ColorScheme = Object.assign(Object.assign({}, Status), { primary: "primary", secondary: "secondary", gray: "gray" });
export const VariantColor = ColorScheme;
export const Spacing = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    8: 8,
    10: 10,
    12: 12,
    16: 16,
    20: 20,
    24: 24,
    32: 32,
    40: 40,
    48: 48,
    56: 56,
    64: 64,
};
export const Align = {
    start: "flex-start",
    end: "flex-end",
    center: "center",
};
export const Justify = {
    start: "flex-start",
    end: "flex-end",
    center: "center",
    between: "space-between",
    around: "space-around",
    evenly: "space-evenly",
};
export const Placement = {
    top: "top",
    bottom: "bottom",
    left: "left",
    right: "right",
};
export const Direction = {
    column: "column",
    columnReverse: "column-reverse",
    row: "row",
    rowReverse: "row-reverse",
};
//# sourceMappingURL=constants.js.map